import React, {useEffect, useState} from 'react';
import {NoSsr, MenuItem, IconButton, InputAdornment, CircularProgress, Backdrop, Hidden} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ColAtm from '../../../../atomic/Col/Col';
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import axios from "axios";
import { getAppLang, getProperty } from '../../../../../utils';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { BOOKING_ENGINE_REPORT } from '../../../../../constants/api.constants';
import { PageTitle } from '../../../../atomic/PageHeader/PageTitle';
import {Animated} from "react-animated-css";
import { BOOKING_ENGINE } from '../../../../../constants/appUrls.constants';
import { NETWORK_COUPONS } from '../../../../../constants/api.constants';
import PageHeaderAtm from '../../../../atomic/PageHeader/PageHeader';
import Container from "@material-ui/core/Container";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {SelectValidator, TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import {useForm} from "react-hook-form";
import {MuiPickersUtilsProvider, DatePicker} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import deLocale from "date-fns/locale/de";
import trLocale from "date-fns/locale/tr";
import {makeStyles} from "@material-ui/core/styles";
import { USER_MENU } from '../../../../../constants/api.constants';
import { DateRangePicker } from 'react-dates';
import ButtonAtm from '../../../../atomic/Button/Button';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash/debounce';
import ClearIcon from '@material-ui/icons/Clear';
import { NETWORK_COUPONS_CHANNEL_LIST } from '../../../../../constants/appUrls.constants';
import { NETWORK_COUPON_CODE_REPORTS } from '../../../../../constants/api.constants';
import { Code } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import { NETWORK_RESERVATION_DETAIL_SHORT } from '../../../../../constants/appUrls.constants';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#d71f26',
    },
}))

export default function CouponReports() {

    let fromRange = '29/03/2020';
    const {t} = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();
    const localeMap = {
        es: esLocale,
        de: deLocale,
        tr: trLocale
    };
    const location = useLocation();

    const [report, setReport] = useState([]);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [startDate, setStartDate] = useState(moment().subtract(90, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [loadingSpinner, setLoadingSpinner] = useState(false);
    const [hotelName, setHotelName] = useState('');
    const [focusedInput, setFocusedInput] = useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [couponCodeInput, setCouponCodeInput] = useState('');
    const [couponCodeStatus, setCouponCodeStatus] = useState(1);

    useEffect(() => {
        fetchTitle();
    },[]);

    useEffect(() => {
        if (location.state) {
            const { code, status, startDate, endDate } = location.state;
            setCouponCodeInput(code ?? '');
            setCouponCodeStatus(status ?? 1);
            setIsFirstLoad(false);
            fetchReport(code, status, startDate, endDate);
        } else {
            fetchReport(null, null, startDate, endDate);
        }
    }, [location.state]);

    const fetchReport = (couponCode, status, start_date, end_date) => {
        setIsFirstLoad(false);
        setLoadingSpinner(true);
        setIsButtonDisabled(true);

        const params = {
            params: {
                property_id: getProperty(),
                channel_id : 1,
                code: couponCode?.trim() || null,
                status: status === "all" ? null : status,
                start_date : start_date === undefined ? moment().subtract(90, 'days').format('YYYY-MM-DD') : start_date, // Bugünden 3 ay önce
                finish_date : end_date === undefined ? moment().format('YYYY-MM-DD') : end_date, // Bugün
            }
        }
        axios.post(NETWORK_COUPON_CODE_REPORTS, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setReport(result.data.data)
            setLoadingSpinner(false)
            setIsButtonDisabled(false)
        }).catch(function (error) {
            console.log(error);
            setLoadingSpinner(false);
            setIsButtonDisabled(false);
        });
    }

    const fetchTitle = () => {
        const params = {
            params: {
                property_id: getProperty(),
            }
        }
        axios.post(USER_MENU, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setHotelName(result.data.data.property_list[0].name + " - ");
        }).catch(function (error) {
            console.log(error);
        });
    }

    const handleChangeType = ({target}) => {
        setCouponCodeStatus(target.value)
    }

    const onSubmit = (e) => {
        fetchReport(couponCodeInput, couponCodeStatus, moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"));
    };

    const enterStartDate = (date, id, e) => {
        setStartDate(date)
    }

    const enterEndDate = (date, id, e) => {
        setEndDate(date)
    }

    const isOutsideRange = (day => {
        let dayIsBlocked = false;
        if(day > moment(fromRange)) {
            dayIsBlocked = true;
        }
        return dayIsBlocked;
    })

    const onCouponCodeInput = (e) => {
        setCouponCodeInput(e.target.value)
    }

    return (
        <NoSsr>
            <PageTitle title={ t('btn-coupon_reports-title') } />
            <PageHeaderAtm exitText={ t('btn-dashboard') } backButton={NETWORK_COUPONS_CHANNEL_LIST} text={ hotelName + t('btn-coupon_reports-title')} />
            <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width pb-0">
                        <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 daily-filter-box">
                            <Grid container className="details-title detail-title-mob" style={{width:"auto"}}>
                                <h2 style={{marginTop:"35px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-table-toolbar-filters') }</h2>
                            </Grid>
                            <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                <Divider />
                            </Grid>
                            <Grid container spacing={2} xs={12}>
                                <ValidatorForm className='d-flex-block w-100' onSubmit={handleSubmit(onSubmit)}>
                                    <Grid item xs={3} className='m-w-100-m coupon-textfield' style={{paddingRight: "40px", marginLeft: "1rem"}}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            placeholder={t('be-coupon_code')}
                                            value={couponCodeInput == null ? '' : couponCodeInput}
                                            onChange={(e) => onCouponCodeInput(e)}
                                            style={{backgroundColor: '#fff', borderRadius: 8, color: '#2d3039'}}
                                            InputProps={{
                                                endAdornment: (
                                                    couponCodeInput && (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="clear search"
                                                                onClick={() => {
                                                                    setCouponCodeInput('')
                                                                }}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                                <ClearIcon style={{color: '#2d3039'}} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                ),
                                            }}
                                            inputProps={{
                                                style: { fontSize: 16, paddingTop: 20, paddingBottom: 20, borderRadius: 8, color:'#2d3039'},
                                                'aria-label': 'search',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2} className='m-w-100-m' style={{marginRight: "40px"}}>
                                        <SelectValidator
                                            name="addon_type"
                                            className="form-control w-100-m booking-status-box"
                                            variant="outlined"
                                            fullWidth
                                            // style={{width:"263px"}}
                                            label={ t('enw-input-status') }
                                            value={couponCodeStatus}
                                            onChange={handleChangeType}
                                        >
                                            <MenuItem value={"all"}>{ t('datatable-filter-all') }</MenuItem>
                                            <MenuItem value={0}>{ t('enw-payment_transaction-status-cancel_refund') }</MenuItem>
                                            <MenuItem value={1}>{ t('enw-channels-channel_setup-booking-title') }</MenuItem>
                                            <MenuItem value={2}>{ t('enw-reservation-prebooking') }</MenuItem>
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={5} className='m-w-100-m mt-18'>
                                        <Hidden smUp>
                                            <DateRangePicker
                                                startDate={startDate}
                                                endDate={endDate}
                                                startDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                endDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                onDatesChange={({ startDate, endDate }) => {
                                                    enterStartDate(startDate);
                                                    enterEndDate(endDate);
                                                }}
                                                focusedInput={focusedInput}
                                                onFocusChange={setFocusedInput}
                                                isOutsideRange={isOutsideRange}
                                                initialVisibleMonth={() => moment().subtract(1, "month")}
                                                orientation={"horizontal"}
                                                // disabled={dateType === ""}
                                                numberOfMonths={1}
                                                minimumNights={0}
                                                displayFormat={"DD.MM.YYYY"}
                                                // required
                                                readOnly
                                                // minDate={moment().subtract(180, 'days')}
                                                maxDate={moment(startDate).add(179, 'days')}
                                            />
                                        </Hidden>
                                        <Hidden xsDown>
                                            <DateRangePicker
                                                startDate={startDate}
                                                endDate={endDate}
                                                startDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                endDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                onDatesChange={({ startDate, endDate }) => {
                                                    enterStartDate(startDate);
                                                    enterEndDate(endDate);
                                                }}
                                                focusedInput={focusedInput}
                                                onFocusChange={setFocusedInput}
                                                isOutsideRange={isOutsideRange}
                                                initialVisibleMonth={() => moment().subtract(1, "month")}
                                                orientation={"horizontal"}
                                                // disabled={dateType === ""}
                                                // numberOfMonths={2}
                                                minimumNights={0}
                                                displayFormat={"DD.MM.YYYY"}
                                                // required
                                                readOnly
                                                // minDate={moment().subtract(180, 'days')}
                                                maxDate={moment(startDate).add(179, 'days')}
                                            />
                                        </Hidden>
                                    </Grid>
                                    <Grid xs={2} className='mlt-2-rem-report report-btn' style={{marginRight: "1rem"}}>
                                        <ButtonAtm
                                            className="m-auto room-rate-modal-save bg-red"
                                            style={{width: "100%"}}
                                            type="submit"
                                            buttontext={ t('enw-table-toolbar-filters') }
                                            color="primary"
                                            id="submitFilters"
                                            title={startDate && endDate !== null ? '' : t('enw-input-start_and_end_date-warn')}
                                            disabled={isButtonDisabled || (startDate && endDate !== null ? false : true)}
                                        />
                                </Grid>
                                </ValidatorForm>
                            </Grid>
                                    
                        </ColAtm>
                    <ColAtm className="booking-list coupon-report-table" style={{maxWidth: "75%", margin: "32px auto"}}>
                        {loadingSpinner ? (
                            <div style={{padding: '32px', textAlign: 'center', color: '#888', fontSize: '18px', background: '#fff', borderRadius: 8, minHeight: 90}}>
                                <CircularProgress className='circularProgress-coupon-report' style={{color:"#d71f26", zIndex: "99"}} />
                            </div>
                        ) : isFirstLoad ? (
                            <div style={{padding: '32px', textAlign: 'center', color: '#888', fontSize: '18px', background: '#fff', borderRadius: 8}}>
                                {t('enw-coupon_reports_search_info-desc')}
                            </div>
                        ) : Array.isArray(report) && report.length > 0 ? (
                            <TableContainer className='m-h-100-table' style={{maxHeight: "500px", background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)'}}>
                                <Table stickyHeader sx={{ minWidth: 900 }} aria-label="booking table" id="booking-table" style={{border: "0px solid"}}>
                                    <TableHead>
                                        <TableRow style={{background: '#fafafa'}}>
                                            <TableCell>{ t('be-coupon_code') }</TableCell>
                                            <TableCell>{ t('enw-reservation-table-reservation_number') }</TableCell>
                                            <TableCell>{ t('enw-input-name_surname') }</TableCell>
                                            <TableCell>{ t('enw-input-start') }</TableCell>
                                            <TableCell>{ t('enw-input-end') } </TableCell>
                                            {/* <TableCell>{ t('enw-dashboard-length_of_stay') }</TableCell> */}
                                            <TableCell>{ t('enw-offer-dashboard-total-count') }</TableCell>
                                            <TableCell>{ t('enw-input-status') }</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {report.map((item) => (
                                            <TableRow key={item?.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell data-label={ t('be-coupon_code') }>{item?.code}</TableCell>
                                                <TableCell data-label={ t('enw-reservation-table-reservation_number') }><a href={NETWORK_RESERVATION_DETAIL_SHORT + item?.id} target="_blank">{item?.booking_code}</a></TableCell>
                                                <TableCell data-label={ t('enw-input-name_surname') }>{item?.name_surname}</TableCell>
                                                <TableCell data-label={ t('enw-input-start') }>{moment(item?.checkin_date).format('DD.MM.YYYY')}</TableCell>
                                                <TableCell data-label={ t('enw-input-end') }>{moment(item?.checkout_date).format('DD.MM.YYYY')}</TableCell>
                                                {/* <TableCell>{item?.length_of_stay}</TableCell> */}
                                                <TableCell data-label={ t('enw-offer-dashboard-total-count') }>{item?.total_formatted} {item?.currency_code}</TableCell>
                                                <TableCell data-label={ t('enw-input-status') }>
                                                    {item?.status === 1 ? (
                                                        <span style={{background: '#e0f7e9', color: '#007e33', padding: '4px 12px', borderRadius: 12, fontWeight: 600}}>{t(item?.status_language_key)}</span>
                                                    ) : item?.status === 2 ? (
                                                        <span style={{background: '#fff4e0', color: '#f80', padding: '4px 12px', borderRadius: 12, fontWeight: 600}}>{t(item?.status_language_key)}</span>
                                                    ) : (
                                                        <span style={{background: '#ffeaea', color: '#c00', padding: '4px 12px', borderRadius: 12, fontWeight: 600}}>{t(item?.status_language_key)}</span>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {report.length > 0 && (() => {
                                            const totals = {};
                                            report.forEach(item => {
                                                const cur = item.currency_code;
                                                const val = parseFloat(
                                                    (item.total_formatted + '').replace('.', '').replace(',', '.')
                                                );
                                                if (!totals[cur]) totals[cur] = 0;
                                                totals[cur] += isNaN(val) ? 0 : val;
                                            });
                                            return (
                                                <>
                                                    <TableRow>
                                                        <TableCell className='tbl-sum' colSpan={5} style={{ fontWeight: 800, textAlign: 'left', background: '#f6f8fc' }}>
                                                            { t('web-offer-total') }
                                                        </TableCell>
                                                        <TableCell data-label={t('web-offer-total')}  style={{ fontWeight: 800, background: '#f6f8fc' }}>
                                                        {Object.entries(totals).map(([cur, sum]) =>
                                                                <span key={cur} style={{fontWeight: 800, marginRight: Object.entries(totals).length > 1 ? 16 : 0}}>
                                                                    {sum.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} {cur}
                                                                </span>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className='text-center' colSpan={7} style={{ fontWeight: 800, textAlign: 'left', background: '#f6f8fc', textAlign:'center' }}>
                                                            {t('web-offer-total')}  {t('enw-coupon-dashboard-title')}: {report?.length}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            );
                                        })()}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <div style={{padding: '32px', textAlign: 'center', color: '#888', fontSize: '18px', background: '#fff', borderRadius: 8}}>
                                {t('enw-cpa-data_not_found')}
                            </div>
                        )}
                        </ColAtm>
                    </div>
                </Container>
                <style>{`
                    .booking-list > div td,
                    .booking-list > div th {
                        text-align:center
                    }
                    .booking-list > div td {
                        padding-top: 20px !important;
                        padding-bottom: 20px !important;
                    }
                    .booking-status-box > .MuiInputBase-formControl {
                        padding-bottom:3px;
                    }
                    @media screen and (max-width: 768px) {
                        .booking-list > div table {
                            border: 0 !important;
                        }

                        .booking-list > div table caption {
                            font-size: 1.3em !important;
                        }
                        
                        .booking-list > div table thead {
                            border: none!important;
                            clip: rect(0 0 0 0)!important;
                            height: 1px!important;
                            margin: -1px!important;
                            overflow: hidden!important;
                            padding: 0!important;
                            position: absolute!important;
                            width: 1px!important;
                        }
                        
                        .booking-list > div table tr {
                            border-bottom: 3px solid #ddd!important;
                            display: block!important;
                            margin-bottom: .625em!important;
                        }
                        
                        .booking-list > div table td {
                            border-bottom: 1px solid #ddd!important;
                            display: block;
                            font-size: .8em!important;
                            text-align: right;
                        }
                        
                        .booking-list > div table td::before {
                            content: attr(data-label)!important;
                            float: left!important;
                            font-weight: bold!important;
                            // text-transform: uppercase!important;
                        }
                        
                        .booking-list > div table td:last-child {
                            border-bottom: 0!important;
                        }
                        .booking-list > div td {
                            text-align:right;
                        }
                        .booking-list > div tr:nth-child(even) {
                            border-radius:4px;
                        }
                        .tbl-sum-last-row {
                            display:none !important;
                        }
                    }
                    tr:nth-child(even) a {
                        color: #1890ff !important;
                        background-color: transparent !important;
                        border-radius:0px!important;
                        padding:0!important;
                    }
                    .tbl-sum {
                        text-align:left!important
                    }
                    @media screen and (min-width: 768px) {
                        .tbl-sum {
                            padding-left:48px !important;
                        }
                    }
                    @media screen and (max-width: 768px) {
                        .tbl-sum {
                            display:none !important;
                        }
                    }
            `}</style>
            </Animated>
        </NoSsr>
    ) 
}
